import { convertIsoToDate } from "../../Utils/js-common";
import { classNames } from "../Styles/CustomCardWithMetrics.styles";

// Helper: Render applied filters
export const AppliedFilters = ({ metricFilters }: { metricFilters: { [key: string]: any } }) => {
  const entries = Object.entries(metricFilters);
  if (!entries.length) return null;
  return (
    <div className={classNames.appliedFiltersContainer}>
      {entries.map(([key, val]) => (
        <div key={key} style={{ display: "flex" }}>
          <div className={`${classNames.layoutText} ${classNames.nameText}`}>{key}</div>
          <div className={classNames.essentialsSeparator}>:</div>
          <div className={`${classNames.layoutText} ${classNames.secondaryText}`}>
            {convertIsoToDate(val?.toString()) || "(empty)"}
          </div>
        </div>
      ))}
    </div>
  );
};
